import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Label from '../../../components/Label';
import {TableEditBar} from '../../../components/TableEditBar';
import {PaginatiorInfo} from '../../../graphql/common.datatypes';
import {getWcvType, WcvLog, WcvLogLevels} from '../../../graphql/logs.datatypes';
import {EST, formatDateTime} from '../../../utils/formatters';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
}));

const Results = (props: {
    className?: string,
    logs: WcvLog[],
    paginatorInfo: PaginatiorInfo,
    setPage: (page: number) => void,
    rowsPerPage: number,
    setRowsPerPage: (rowsPerPage: number) => void,
    selectedLog?: WcvLog,
    setSelectedLog: (log: WcvLog) => void,
    notes: boolean,
    hideType: boolean,
}) => {
    const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, selectedLog, setSelectedLog, logs, notes, hideType, ...rest} = props;
    const classes = useStyles();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setRowsPerPage(Number(event.target.value));
    };

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                <CardHeader
                  title={notes ? 'Notes' : 'Logs'}
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{width: 215}}>Timestamp</TableCell>
                                        {!hideType && (<TableCell style={{width: 100}}>Type</TableCell>)}
                                        <TableCell style={{width: 100}}>Level</TableCell>
                                        <TableCell style={{width: 100}}>Code</TableCell>
                                        <TableCell>Description</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {logs.map(log => {
                                        const logLevel = WcvLogLevels[log.level];
                                        const logType = getWcvType(log.type);

                                        return (
                                        <TableRow
                                            hover
                                            key={log.id}
                                            selected={selectedLog === log}
                                            onClick={() => setSelectedLog(log)}
                                        >
                                          <TableCell>{formatDateTime(log.created_at)}</TableCell>
                                            {!hideType && (<TableCell>{logType && (<Label color={logType.colour}>{logType.name}</Label>)}</TableCell>)}
                                            <TableCell>{logLevel && (<Label color={logLevel.colour}>{logLevel.name}</Label>)}</TableCell>
                                            <TableCell>{log.code}</TableCell>
                                            <TableCell>{log.description}</TableCell>

                                        </TableRow>
                                    )})}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                <CardActions className={classes.actions}>
                    <TablePagination
                      component="div"
                      count={paginatorInfo.total}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      page={paginatorInfo.currentPage - 1}
                      rowsPerPage={rowsPerPage}
                      rowsPerPageOptions={[25, 50, 100]}
                    />
                </CardActions>
            </Card>
            <TableEditBar selected={[]}/>
        </div>
    );
};

export default Results;
